import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const UpdateFamilyEnrollmentMutation = graphql.persisted(
  "UpdateFamilyEnrollment",
  graphql(`
    mutation UpdateFamilyEnrollment($input: UpdateFamilyEnrollmentInput!) {
      updateFamilyEnrollment(input: $input) {
        familyEnrollment {
          id state enrollmentKind inviteStatus isInquiry additionalPaymentOptionKeys
          enrollmentFee { kind amountCents }
        }
        userErrors { message path }
      }
    }
  `)
);

export { UpdateFamilyEnrollmentMutation };

export function useUpdateFamilyEnrollment() {
  return useMutation(UpdateFamilyEnrollmentMutation);
}
